import React from 'react';

import { KeyValueViewProps } from './types';
import KeyValueRenderer from './KeyValueRenderer';

const KeyValueView = ({
	keyConfig,
	keyValueLayout,
	forceUpdate,
	turnForceUpdateOff,
	getActionList,
	getActionHandler
}: KeyValueViewProps) => {
	return (
		<KeyValueRenderer
			keyConfig={keyConfig}
			keyValueLayout={keyValueLayout}
			forceUpdate={forceUpdate}
			getActionHandler={getActionHandler}
			getActionList={getActionList}
			turnForceUpdateOff={turnForceUpdateOff}
		/>
	);
};

export default KeyValueView;
